import React, { useMemo } from 'react';
import { Button, Tooltip, Dropdown, Space } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPalette } from '@fortawesome/pro-light-svg-icons';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../theme';
import type { MenuProps } from 'antd';

export const ThemeToggle: React.FC<{ className?: string }> = ({ className }) => {
    const { t } = useTranslation();
    const { currentThemeId, setTheme, availableThemes } = useTheme();

    const handleThemeChange = (themeId: string) => {
        setTheme(themeId as any);
    };

    const menuItems: MenuProps['items'] = useMemo(() =>

        availableThemes.map((theme) => {
            const isActive = theme.id === currentThemeId;
            return {
                key: theme.id,
                label: (
                    <Space>
                        <div
                            style={{
                                width: '12px',
                                height: '12px',
                                borderRadius: '50%',
                                background: theme.category === 'dark' ? '#ffffff' : '#ffffff',
                                border: isActive ? '2px solid #1890ff' : '1px solid #d9d9d9',
                            }}
                        />
                        <span style={{
                            fontWeight: isActive ? 'bold' : 'normal',
                            color: isActive ? '#1890ff' : 'inherit'
                        }}>
                            {t(theme.name)}
                        </span>
                        {isActive && <span style={{ color: '#1890ff', fontSize: '12px' }}>✓</span>}
                    </Space>
                ),
                onClick: () => handleThemeChange(theme.id),
            };
        }), [availableThemes, handleThemeChange, currentThemeId]);

    return (
        <Tooltip title={`${t('messages.theme.change_theme')}`}>
            <Dropdown
                className={className}
                menu={{
                    items: menuItems,
                    selectedKeys: [currentThemeId]
                }}
                trigger={['click']}

            >
                <Button
                    shape="circle"
                    icon={<FontAwesomeIcon icon={faPalette} />}
                />
            </Dropdown>
        </Tooltip>
    );
};
